import { trackRyteEvent } from "@/features/ryteTracker/utils/telemetry/trackRyteEvent";

/**
 * Canonical telemetry for NON-network RYTE UI interactions — panel open/close
 * cycles, toolbar buttons, popover/chrome clicks. Distinct from
 * `trackRyteActionResult` (which is for goal-mutation API actions and always
 * carries an `outcome`): UI events have no success/failure, they're
 * engagement signals ("how active is the operator, what do they toggle").
 *
 * Emits the given event verbatim with a uniform `data` shape so engagement
 * dashboards slice consistently. The `trigger` field is the key dimension for
 * open/close questions: it distinguishes a DELIBERATE close (close_button)
 * from an AUTOMATIC one (swap to another puck, site change), which is what
 * makes "how often do they close then reopen" answerable.
 *
 * Naming convention (matches existing `ryte_*` vocabulary):
 *   - panel cycles: `ryte_detail_panel_opened` / `_closed`,
 *     `ryte_queue_panel_opened` / `_closed`
 *   - toolbar: `ryte_toolbar_<thing>_opened` (filters/permissions/info),
 *     `ryte_toolbar_download`
 *   - chrome: `ryte_<surface>_<action>` (e.g. `ryte_door_filter_cleared`)
 */
interface RyteUiMeta {
  /** Why the interaction happened — the load-bearing dimension for open/close
   *  cycle analysis: "close_button" | "swap" | "site_change" | "select" |
   *  "reopen" | "toggle" | etc. */
  trigger?: string;
  /** Active site filter dimension. */
  yardId?: string;
  [key: string]: unknown;
}

export const trackRyteUiEvent = (eventName: string, meta: RyteUiMeta = {}): void => {
  trackRyteEvent({
    eventName,
    message: `RYTE UI: ${eventName}`,
    data: { ...meta },
  });
};
